export const GoogleMapsAPIKey = 'AIzaSyCb_xtYTdy7pw6uMJzYxQAyO6hD8BuRvh0';
export const GoogleTagsKey = 'G-64QHVGGD88';
export const GoogleCaptchaKey = '6LcjkmAoAA0000==-=QKVoqK_rnh4';